import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { formatImage } from '@ifeng-fe/public_method';
import { getThumbnail } from '@src/common/utils';

class Tabs extends PureComponent {

    static propTypes = {
        content: PropTypes.array
    }

    state = {
        currentIndex: 0
    }

    setCurrentIndex = (index) => {
        this.setState({
            currentIndex: index
        });
    }

    render() {
        const { content } = this.props;
        const { currentIndex } = this.state;
        const activeItem = content[currentIndex];

        return (
            <div className={styles.tabs}>
                {
                    content.length > 1 &&
                    <div className={styles.nav}>
                        {
                            content.map((data, index) => {
                                return (
                                    <div key={index} className={ currentIndex === index ? styles.active : '' } onMouseEnter={() => this.setCurrentIndex(index)}>{data.source}</div>
                                );
                            })
                        }
                    </div>
                }
                <div>
                    <a href={activeItem.url} target="_blank" rel="noreferrer">
                        <div className={styles.first}>
                            <div className={styles.left}>
                                <img src={formatImage(getThumbnail(activeItem), 650 * 2, 370 * 2)} alt="" />
                            </div>
                            <div className={styles.right}>
                                <h1>{activeItem.title}</h1>
                                <p>{activeItem.summary}</p>
                                <span>详情</span>
                            </div>
                        </div>
                    </a>
                    {
                        activeItem.children &&
                        <div className={styles.otherList}>
                            {
                                activeItem.children.map((data, index) => {
                                    return (
                                        <div className={styles.other} key={index}>
                                            <a href={data.url} target="_blank" rel="noreferrer">
                                                <div className={styles.imgWp}>
                                                    <img src={formatImage(getThumbnail(data), 320 * 2, 180 * 2)} alt={data.title} />
                                                </div>
                                                <p>{data.title}</p>
                                            </a>
                                        </div>
                                    );
                                })
                            }
                        </div>
                    }
                </div>
            </div>
        );

    }
}

export default Tabs;
